(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__looxReviewsAccordionBound) return;
  window.__looxReviewsAccordionBound = true;

  const REVIEW_HASHES = ['#looxReviews', '#looxReviewsFrame'];
  const SCROLL_OFFSET = 120;

  const getReviewsDetails = () => {
    const target = document.getElementById('looxReviewsFrame') || document.getElementById('looxReviews');
    return target?.closest('details.accordion__details') || null;
  };

  const openReviewsAccordion = () => {
    const details = getReviewsDetails();
    if (!details) return null;

    if (!details.open) {
      const accordion = details.closest('accordion-component');
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');

      if (accordion && typeof accordion.toggleOpen === 'function' && summary && content) {
        accordion.toggleOpen({
          willOpen: true,
          item: details,
          summary,
          content,
          shouldScroll: false,
        });
      } else {
        details.open = true;
        details.classList.add('is-open');
        summary?.setAttribute('aria-expanded', 'true');
      }
    }

    return details;
  };

  const scrollToReviews = () => {
    const details = openReviewsAccordion();
    const target = details?.querySelector('summary') || document.getElementById('looxReviews');
    if (!target) return;

    requestAnimationFrame(() => {
      if (window.FoxTheme?.utilities?.smoothScrollTo) {
        window.FoxTheme.utilities.smoothScrollTo(target, SCROLL_OFFSET);
        return;
      }

      const lenis = window.FoxTheme?.utilities?.getLenis?.();
      const currentScroll = lenis ? lenis.scroll : window.scrollY || document.documentElement.scrollTop || 0;
      const top = Math.max(0, target.getBoundingClientRect().top + currentScroll - SCROLL_OFFSET);

      if (lenis) {
        lenis.scrollTo(top, { immediate: false, duration: 1.2 });
        return;
      }

      window.scrollTo({ top, behavior: 'smooth' });
    });
  };

  const isReviewsLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return false;
    const href = link.getAttribute('href') || '';
    return REVIEW_HASHES.some((hash) => href === hash || href.endsWith(hash));
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!isReviewsLink(link)) return;

      event.preventDefault();
      const href = link.getAttribute('href');
      const hash = REVIEW_HASHES.find((item) => href === item || href.endsWith(item)) || '#looxReviewsFrame';
      history.pushState(null, '', hash);
      scrollToReviews();
    },
    true
  );

  const openFromHash = () => {
    if (!REVIEW_HASHES.includes(location.hash)) return;
    scrollToReviews();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash, { once: true });
  } else {
    openFromHash();
  }

  window.addEventListener('hashchange', openFromHash);
  window.addEventListener('popstate', openFromHash);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  const SCROLL_OFFSET = 120;

  const getTarget = () =>
    document.querySelector('#product-add-to-cart') ||
    document.querySelector('.product-information .product-form-buttons') ||
    document.querySelector('product-form-component .add-to-cart-button');

  const scrollToAddToCart = () => {
    const target = getTarget();
    if (!target) return;

    if (window.FoxTheme?.utilities?.smoothScrollTo) {
      window.FoxTheme.utilities.smoothScrollTo(target, SCROLL_OFFSET);
      return;
    }

    const lenis = window.FoxTheme?.utilities?.getLenis?.();
    const currentScroll = lenis ? lenis.scroll : (window.scrollY || document.documentElement.scrollTop || 0);
    const top = Math.max(0, target.getBoundingClientRect().top + currentScroll - SCROLL_OFFSET);

    if (lenis) {
      lenis.scrollTo(top, { immediate: false, duration: 1.2 });
      return;
    }

    window.scrollTo({ top, behavior: 'smooth' });
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href="#product-add-to-cart"], a[href*="product-add-to-cart"]');
      if (!link) return;

      event.preventDefault();
      event.stopPropagation();
      history.pushState(null, '', '#product-add-to-cart');
      scrollToAddToCart();
    },
    true
  );

  const keepQtyBesideAddToCart = () => {
    const formButtons = document.querySelector('#product-add-to-cart.product-form-buttons');
    if (!formButtons) return;

    let actions = formButtons.querySelector(':scope > .product-form-buttons__actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'product-form-buttons__actions';
      formButtons.appendChild(actions);
    }

    const qty =
      formButtons.querySelector('[id^="QuantitySelectorWrapper-"]') ||
      formButtons.querySelector('.product-form-buttons__quantity');
    const atc = formButtons.querySelector('add-to-cart-component');

    // Seal injects inside <add-to-cart-component>, which sits beside quantity.
    // Move Seal widgets above the qty + ATC row so purchase options stay full width.
    const moveSealAboveActions = (root) => {
      if (!root) return;
      Array.from(root.children).forEach((child) => {
        if (
          child.classList?.contains('sealsubs-target-element') ||
          child.classList?.contains('sealsubs-container') ||
          child.matches?.('[data-seal-ac], [data-seal-in]')
        ) {
          formButtons.insertBefore(child, actions);
        }
      });
    };

    moveSealAboveActions(atc);
    moveSealAboveActions(actions);

    // Also hoist any Seal nodes still nested under ATC/actions
    formButtons
      .querySelectorAll(
        'add-to-cart-component .sealsubs-container, add-to-cart-component .sealsubs-target-element, .product-form-buttons__actions .sealsubs-container, .product-form-buttons__actions .sealsubs-target-element'
      )
      .forEach((widget) => {
        if (widget.parentElement !== formButtons) {
          formButtons.insertBefore(widget, actions);
        }
      });

    if (qty && qty.parentElement !== actions) {
      actions.insertBefore(qty, actions.firstChild);
    }
    if (atc && atc.parentElement !== actions) {
      actions.appendChild(atc);
    }
  };

  const scheduleFix = () => {
    requestAnimationFrame(keepQtyBesideAddToCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFix, { once: true });
  } else {
    scheduleFix();
  }

  document.addEventListener('shopify:section:load', scheduleFix);
  window.addEventListener('load', scheduleFix);
  [300, 800, 1600, 3000].forEach((ms) => setTimeout(scheduleFix, ms));

  const observeRoot = document.querySelector('product-form-component') || document.body;
  if (observeRoot && typeof MutationObserver !== 'undefined') {
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        keepQtyBesideAddToCart();
      });
    });
    observer.observe(observeRoot, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
